module.exports = __webpack_public_path__ + "img/dia_postBg.3579ba92.jpg";